import { address } from "@solana/kit"

// Kept free of Metaplex/umi so the gift button can validate addresses without
// pulling the transfer builders into its bundle.

export class GachaPortfolioTransferError extends Error {
  constructor(
    message: string,
    readonly code:
      | "invalid-address"
      | "missing-source-account"
      | "rpc-error"
      | "wallet-cancelled"
      | "locked"
      | "insufficient-sol",
  ) {
    super(message)
    this.name = "GachaPortfolioTransferError"
  }
}

export function validateSolanaRecipientAddress(value: string) {
  const trimmed = value.trim()
  if (!trimmed) {
    throw new GachaPortfolioTransferError(
      "Invalid Solana address.",
      "invalid-address",
    )
  }

  try {
    return address(trimmed)
  } catch {
    throw new GachaPortfolioTransferError(
      "Invalid Solana address.",
      "invalid-address",
    )
  }
}
